module.exports = __webpack_public_path__ + "img/secure-folder.4ffa8bbe.svg";